"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flagSet = exports.remoteVectorImageFormatExtensions = exports.remoteImageFormats = exports.remoteFontFormats = exports.remoteFormats = exports.remoteFontFormatWOFF = exports.remoteImageFormatWEBP = exports.remoteImageFormatPNG = exports.remoteImageFormatXML = exports.remoteImageFormatSVG = exports.baseCdnUrl = void 0;
exports.baseCdnUrl = "https://t-cf.bstatic.com/design-assets/assets";
exports.remoteImageFormatSVG = {
    type: "image",
    extension: "svg",
    isVector: true,
};
exports.remoteImageFormatXML = {
    type: "image",
    extension: "xml",
    isVector: true,
};
exports.remoteImageFormatPNG = {
    type: "image",
    extension: "png",
    isVector: false,
};
exports.remoteImageFormatWEBP = {
    type: "image",
    extension: "webp",
    isVector: false,
};
exports.remoteFontFormatWOFF = {
    type: "font",
    extension: "woff",
};
/// When creating a new remote format, add it into this array in order to enable codegen to populate
/// newly added formats as distinguished vector image format, raster image format, or font format.
exports.remoteFormats = [
    exports.remoteImageFormatSVG,
    exports.remoteImageFormatXML,
    exports.remoteImageFormatPNG,
    exports.remoteImageFormatWEBP,
    exports.remoteFontFormatWOFF,
];
exports.remoteFontFormats = exports.remoteFormats.filter(function (f) { return f.type === "font"; });
exports.remoteImageFormats = exports.remoteFormats.filter(function (f) { return f.type === "image"; });
var remoteVectorImageFormats = exports.remoteImageFormats.filter(function (f) { return f.isVector; });
exports.remoteVectorImageFormatExtensions = remoteVectorImageFormats.map(function (f) { return f.extension; });
/**
 * We store the name of the flags set here to have access to it when constructing a URL
 * We use it to only upload light mode flags, since they legally can't have dark mode
 */
exports.flagSet = "images-flags";
